module.exports = __webpack_public_path__ + "static/media/concours-totalement-mb-fr.898a1623.jpg";